module.exports = __webpack_public_path__ + "static/img/city07.0a2671e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/city07.jpg
// module id = rro+
// module chunks = 0